import React from 'react'
import { INTEGRATION_WORKFLOWMAX_CONNECTED } from 'constants/redirectEvents'
import { RegisterEventRedirectOnClick } from 'utils/eventRedirect'
import Warning from 'atoms/Warning'
import { StyledLink } from 'atoms/Link'

export default () => (
  <Warning>
    Please connect WorkflowMax account
    {' '}
    <RegisterEventRedirectOnClick
      event={INTEGRATION_WORKFLOWMAX_CONNECTED}
      component={StyledLink}
      to="/integrations"
    >
      here
    </RegisterEventRedirectOnClick>
  </Warning>
)
